import chroma from "chroma-js";
export var spacingBuilder = {
    /** quark = 4 */
    quark: 4,
    /** nano = 8 */
    nano: 8,
    /** xxxs = 16 */
    xxxs: 16,
    /** xxs = 24 */
    xxs: 24,
    /** xs = 32 */
    xs: 32,
    /** sm = 40 */
    sm: 40,
    /** md = 48 */
    md: 48,
    /** lg = 56 */
    lg: 56,
    /** xl = 64 */
    xl: 64,
    /** xxl = 80 */
    xxl: 80,
    /** xxxl = 120 */
    xxxl: 120,
    /** huge = 160 */
    huge: 160,
    /** giant = 200 */
    giant: 200,
};
export var fontSizeBuilder = {
    /** xxxs = 12 */
    xxxs: 12,
    /** xxs = 14 */
    xxs: 14,
    /** xs = 16 */
    xs: 16,
    /** sm = 18 */
    sm: 18,
    /** md = 20 */
    md: 20,
    /** lg = 24 */
    lg: 24,
    /** xl = 32 */
    xl: 32,
    /** xxl = 40 */
    xxl: 40,
    /** xxxl = 48 */
    xxxl: 48,
    /** display = 64 */
    display: 64,
    /** giant = 80 */
    giant: 80,
};
export var borderRadiusBuilder = {
    /** none = 0 */
    none: 0,
    /** xs = 4 */
    xs: 4,
    /** sm = 8 */
    sm: 8,
    /** md = 16 */
    md: 16,
    /** lg = 24 */
    lg: 24,
    /** pill = 500 */
    pill: 500,
    /** circular = (number) => number/2 */
    circular: function (size) { return size / 2; },
};
export var borderWidthBuilder = {
    /** none = 0 */
    none: 0,
    /** hairline = 1 */
    hairline: 1,
    /** thin = 2 */
    thin: 2,
    /** thick = 4 */
    thick: 4,
    /** heavy = 8 */
    heavy: 8,
};
export var fixedHeightBuilder = {
    /** nano = 16 */
    nano: 16,
    /** xxs = 18 */
    xxs: 18,
    /** xs = 24 */
    xs: 24,
    /** sm = 32 */
    sm: 32,
    /** md = 40 */
    md: 40,
    /** lg = 44 */
    lg: 44,
    /** xl = 56 */
    xl: 56,
    /** xxl = 64 */
    xxl: 64,
    /** xxxl = 72 */
    xxxl: 72,
    /** giant = 96 */
    giant: 96,
};
export var neutralColorsBuilder = {
    /** pureWhite = #FFFFFF */
    pureWhite: "#FFFFFF",
    /** gray1 = #F2F5F8 */
    gray1: "#F2F5F8",
    /** gray2 = #E9EBEE */
    gray2: "#E9EBEE",
    /** gray3 = #CCD1D6 */
    gray3: "#CCD1D6",
    /** gray4 = #ACB4BA */
    gray4: "#ACB4BA",
    /** gray5 = #737D86 */
    gray5: "#737D86",
    /** gray6 = #5A646E */
    gray6: "#5A646E",
    /** gray7 = #3B454F */
    gray7: "#3B454F",
    /** gray8 = #22272D */
    gray8: "#22272D",
    /** gray9 = #13161A */
    gray9: "#13161A",
    /** gray10 = #080A0D */
    gray10: "#080A0D",
    /** pureBlack = #000000 */
    pureBlack: "#000000",
};
export var lineHeightBuilder = {
    /** default = (number) => number */
    default: function (size) { return size; },
    /** sm = (number) => (number * 115) / 100 */
    sm: function (size) { return (size * 115) / 100; },
    /** md = (number) => (number * 125) / 100 */
    md: function (size) { return (size * 125) / 100; },
    /** lg = (number) => (number * 150) / 100 */
    lg: function (size) { return (size * 150) / 100; },
    /** xl = (number) => (number * 170) / 100 */
    xl: function (size) { return (size * 170) / 100; },
    /** xxl = (number) => (number * 200) / 100 */
    xxl: function (size) { return (size * 200) / 100; },
};
export var titlesBuilder = {
    h1: {
        fontSize: fontSizeBuilder.xl,
        lineHeight: lineHeightBuilder.md(fontSizeBuilder.xl),
        fontWeight: 700,
    },
    h2: {
        fontSize: fontSizeBuilder.lg,
        lineHeight: lineHeightBuilder.md(fontSizeBuilder.lg),
        fontWeight: 700,
    },
    h3: {
        fontSize: fontSizeBuilder.md,
        lineHeight: lineHeightBuilder.md(fontSizeBuilder.md),
        fontWeight: 700,
    },
    h4: {
        fontSize: fontSizeBuilder.md,
        lineHeight: lineHeightBuilder.md(fontSizeBuilder.md),
        fontWeight: 400,
    },
    h5: {
        fontSize: fontSizeBuilder.sm,
        lineHeight: lineHeightBuilder.lg(fontSizeBuilder.sm),
        fontWeight: 700,
    },
    h6: {
        fontSize: fontSizeBuilder.xs,
        lineHeight: lineHeightBuilder.lg(fontSizeBuilder.xs),
        fontWeight: 700,
    },
    h7: {
        fontSize: fontSizeBuilder.xs,
        lineHeight: lineHeightBuilder.lg(fontSizeBuilder.xs),
        fontWeight: 600,
        letterSpacing: 1,
    },
};
export var titlesMobileBuilder = {
    hm1: {
        fontSize: fontSizeBuilder.sm,
        lineHeight: lineHeightBuilder.md(fontSizeBuilder.sm),
        fontWeight: "bold",
    },
    hm2: {
        fontSize: fontSizeBuilder.xxs,
        lineHeight: lineHeightBuilder.md(fontSizeBuilder.xxs),
        fontWeight: "bold",
    },
    hm3: {
        fontSize: fontSizeBuilder.xxxs,
        lineHeight: lineHeightBuilder.lg(fontSizeBuilder.xxxs),
        fontWeight: "semi-bold",
        letterSpacing: 1,
    },
};
export var textsBuilder = {
    p1: {
        fontSize: fontSizeBuilder.xs,
        lineHeight: lineHeightBuilder.md(fontSizeBuilder.xs),
        fontWeight: 400,
    },
    p2: {
        fontSize: fontSizeBuilder.xxs,
        lineHeight: lineHeightBuilder.lg(fontSizeBuilder.xxs),
        fontWeight: 400,
    },
    p3: {
        fontSize: fontSizeBuilder.xxxs,
        lineHeight: lineHeightBuilder.lg(fontSizeBuilder.xxxs),
        fontWeight: 400,
    },
    p4: {
        fontSize: fontSizeBuilder.xxxs,
        lineHeight: lineHeightBuilder.md(fontSizeBuilder.xxxs),
        fontWeight: 400,
        fontStyle: "italic",
    },
};
export var labelsBuilder = {
    l1: {
        fontSize: fontSizeBuilder.xs,
        lineHeight: lineHeightBuilder.default(fontSizeBuilder.xs),
        fontWeight: 500,
    },
    l2: {
        fontSize: fontSizeBuilder.xxs,
        lineHeight: lineHeightBuilder.md(fontSizeBuilder.xxs),
        fontWeight: 500,
    },
    l3: {
        fontSize: fontSizeBuilder.xxs,
        lineHeight: lineHeightBuilder.default(fontSizeBuilder.xxs),
        fontWeight: 700,
    },
    l4: {
        fontSize: fontSizeBuilder.xxxs,
        lineHeight: lineHeightBuilder.default(fontSizeBuilder.xxxs),
        fontWeight: 600,
    },
    l5: {
        fontSize: fontSizeBuilder.xxxs,
        lineHeight: lineHeightBuilder.default(fontSizeBuilder.xxxs),
        fontWeight: 500,
    },
    l6: {
        fontSize: fontSizeBuilder.xxxs,
        lineHeight: lineHeightBuilder.default(fontSizeBuilder.xxxs),
        fontWeight: 700,
    },
};
export var colorsBuilder = {
    primary: {
        pure: "#2600FF",
        lighter: "#E9E5FF",
        light: "#BBAFFF",
        medium: "#3D28BA",
        dark: "#140277",
        darker: "#140277",
    },
    secondary: {
        pure: "#FF005C",
        lighter: "#FFE5EF",
        light: "#FFAFCD",
        medium: "#BA285D",
        dark: "#77022D",
        darker: "#330113",
    },
    highlight: {
        pure: "#FF0C55",
        light: "#FFBACF",
        medium: "#CC0A44",
        dark: "#680522",
    },
    negative: {
        pure: "#FF3541",
        light: "#FFBEC2",
        medium: "#BE3A42",
        dark: "#7A252A",
    },
    positive: {
        pure: "#1ECB4F",
        light: "#B0E1BD",
        medium: "#1D8D3C",
        dark: "#125A26",
    },
    status: {
        positive: "#1ECB4F",
        alert: "#FFAE00",
        negative: "#FF3541",
        neutral1: "#0066FF",
        neutral2: "#3B454F",
        neutral3: "#B83EE3",
        neutral4: "#00344A",
    },
};
export var generatedColorScheme = function (color) {
    return ({
        100: chroma(color).alpha(0.08).hex(),
        200: chroma(color).alpha(0.16).hex(),
        300: chroma(color).alpha(0.24).hex(),
        400: chroma(color).alpha(0.32).hex(),
        500: chroma(color).alpha(0.4).hex(),
        600: chroma(color).alpha(0.48).hex(),
        700: chroma(color).alpha(0.56).hex(),
        800: chroma(color).alpha(0.64).hex(),
        pure: chroma(color).alpha(1).hex(),
    });
};
export var colorSchemes = {
    green: generatedColorScheme(colorsBuilder.positive.pure),
    blue: generatedColorScheme(colorsBuilder.status.neutral1),
    yellow: generatedColorScheme(colorsBuilder.status.alert),
    red: generatedColorScheme(colorsBuilder.negative.pure),
};
